import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion, Box, Text } from "@chakra-ui/react";
import { BlockHeader } from "../../../../../../../components/BlockHeader";
import { MissingDataLabel } from "../../../../../components/MissingDataLabel";
import { QuestionAccordionItem } from "./QuestionsAndAnswers";

const accountedTypes = ["stationaryAccounted", "mobileAccounted", "fugitiveAccounted"];

function ScopeOneQuestions({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData.aggregatedGeneralAndScope1And2Data.scopeOne"
  });

  const mapBooleanAnswer = (answerString, attrKey, index) => {
    // In this case we show both the answers of 'is an area accounted' boolean question, and the following linked
    // question (total emissions or reason for exclusion)

    const currentKey = attrKey.split("Accounted")[0];
    let isAccountedAnswer;
    let secondQuestionLabel;
    let secondQuestionAnswer;

    if (answerString === "true") {
      const emissionKey = `${currentKey}Emission`;
      const totalEmissionsVal = data[emissionKey][index].answer;
      isAccountedAnswer = t("questions.booleanOptions.yes");
      secondQuestionLabel = t("questions.emissions");
      secondQuestionAnswer = totalEmissionsVal !== null && totalEmissionsVal !== "" && !isNaN(totalEmissionsVal) ?
        Number(totalEmissionsVal)?.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";
    } else if (answerString === "false") {
      const reasonKey = `reason${currentKey.charAt(0).toUpperCase() + currentKey.slice(1)}Exclusion`;
      isAccountedAnswer = t("questions.booleanOptions.no");
      secondQuestionLabel = t("questions.reasonForExclusion");
      secondQuestionAnswer = data[reasonKey][index].answer;
    } else {
      isAccountedAnswer = answerString;
    }

    return <Text
      fontSize="md"
      whiteSpace="break-spaces"
      title={`${isAccountedAnswer}, ${secondQuestionAnswer}`}
    >
      <b>Answer:</b> {isAccountedAnswer}<br />
      <b>{secondQuestionLabel}</b> {secondQuestionAnswer}
    </Text>;
  };

  const mapQuestionAnswers = (attrKey) => {
    return data[attrKey].map((obj, index) => {
      return {
        ...obj,
        customAnswer: mapBooleanAnswer(obj["answer"], attrKey, index)
      };
    });
  };

  return (
    <Box marginTop={10}>
      {/* We are checking for an answer in stationaryAccounted array, because if an answer for a single field is saved
             then answers for all scope one fields are auto saved at that time as well.*/}
      <Box paddingBottom={data && data.stationaryAccounted.length > 0 ? 6 : 0}>
        <BlockHeader
          title={t("title")}
          description={t("subTitle")}
        />
      </Box>
      {data && data.stationaryAccounted.length > 0 ?
        <Accordion defaultIndex={[0]} allowToggle={true}>
          {Object.keys(data).filter(key => accountedTypes.includes(key)).map(attrKey => {
            const answersArr = mapQuestionAnswers(attrKey);
            return <QuestionAccordionItem
              key={`${attrKey}-question`}
              question={t(`questions.${attrKey}`)}
              answers={answersArr}
            />;
          })}
        </Accordion> :
        <MissingDataLabel />}
    </Box>
  );
}

export default ScopeOneQuestions;